export default __webpack_public_path__ + "static/media/cardBg.e78d8761.png";